import { MDBBtn, MDBNavbarItem } from "mdb-react-ui-kit";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import LoginPage from "../../pages/LoginPage";
import AccountMenu from "./AccountMenu";

const Login = ({ setShowBasic }) => {
  const [isOpenLoginModal, setIsOpenLoginModal] = useState(false);
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);

  return (
    <div>
      {isLoggedIn ? (
        <AccountMenu setShowBasic={setShowBasic}/>
      ) : (
        <>
          <MDBNavbarItem className={"me-5"}>
            <MDBBtn color="success" onClick={() => setIsOpenLoginModal(true)}>
              Увійти
            </MDBBtn>
          </MDBNavbarItem>
          <LoginPage
            isOpenLoginModal={isOpenLoginModal}
            setIsOpenLoginModal={setIsOpenLoginModal}
            setShowBasic={setShowBasic}
          />
        </>
      )}
    </div>
  );
};

export default Login;
